<b-modal v-model="modal_requirement_142" size="lg" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="w-100">
          <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
            {{ workSupportMessage }}
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <div v-if="showButtonNoYes">
        <b-button size="sm" variant="outline-primary" @click="executeRearBleeding" class="mx-2"
          :disabled="isLoading || countdown !== 0">
          {{ $t('individual.common_button_no') }}
        </b-button>
        <b-button size="sm" variant="primary" @click="onYesClicked" class="mx-2" :disabled="isLoading">
          {{ $t('individual.common_button_yes') }}
        </b-button>
      </div>
      <div v-else>
        <b-button v-if="showButtonCancel" size="sm" variant="outline-primary" @click="onCancelClicked" class="mx-2"
          :disabled="isLoading">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button v-if="showButtonOk" size="sm" variant="primary" @click="onOkClicked" class="mx-2"
          :disabled="isLoading">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </div>
  </template>
</b-modal>